export default __webpack_public_path__ + "static/media/misc-pantry3.2de437c8.jpg";